import { useMediaQuery } from 'react-responsive';

const MOBILE_BREAKPOINT = 768;

export const Mobile = ({ children }) =>
  useMediaQuery({ maxWidth: MOBILE_BREAKPOINT - 1 }) ? children : null;

export const Desktop = ({ children }) =>
  useMediaQuery({ minWidth: MOBILE_BREAKPOINT }) ? children : null;
